import './styles.scss';

import React, { forwardRef, useCallback, useEffect, useRef } from 'react';

type DropdownProps = {
  children: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  classNames?: string;
  onClose?: () => void;
};

const Dropdown = forwardRef<HTMLDivElement, DropdownProps>(
  ({ children, isOpen, setIsOpen, classNames, onClose }, ref) => {
    const internalRef = useRef<HTMLDivElement>(null);
    const dropdownRef = (ref as React.RefObject<HTMLDivElement>) || internalRef;

    const handleOnClose = useCallback(() => {
      if (isOpen && onClose) {
        onClose();
      }
    }, [isOpen]);

    useEffect(() => {
      const handleClickOutside = (event: any) => {
        const isSelectClick =
          event.target.closest('.dropdown-ignore') ||
          event.target?.closest('.menu-select-container');
        if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !isSelectClick) {
          setIsOpen(false);

          handleOnClose();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [handleOnClose]);

    return (
      <div className={`dropdown ${classNames}`} ref={dropdownRef}>
        {isOpen && <div className="dropdown-content">{children}</div>}
      </div>
    );
  },
);

Dropdown.displayName = 'Dropdown';

export { Dropdown };
